//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectIReferenceAxis.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"Axis",0,"SelectIReferenceAxis",0],[0,"NextThroughPointSolution",0,0],[1,"OrientingFace",0,"ScCollector",0],[1,"PlaneLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"PlaneOrientation",1,0],[0,"PlaneOrientationAxis",1,"Direction",0],[0,"ReverseAxis",1,0],[0,"ReversePlaneNormal",1,0],[1,"Section",0,"Section",0],[0,"ShowAllDatumAxes",1,0],[0,"SketchOrient",1,0]],[],[]];
SPLM.SketchAlongPathBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchAlongPathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchAlongPathBuilder.PlaneOrientationType = Object.freeze({
    "NormalToPath" : "NormalToPath", "NormalToVector" : "NormalToVector", "ParallelToVector" : "ParallelToVector", "ThroughAxis" : "ThroughAxis"});

SPLM.SketchAlongPathBuilder.SketchOrientationType = Object.freeze({
    "Automatic" : "Automatic", "RelativeToFace" : "RelativeToFace", "UseCurveParameters" : "UseCurveParameters"});

export default SPLM;